import React, { Fragment, useContext } from 'react';
import classes from './FluidContentLayout.module.scss';
import { MandatoryChildren } from '../../../models/children-props';
import { TopNavContext } from '../../../providers/TopNavProvider';
import { useTopNavClasses } from '../../../hooks/useTopNavClasees';
import classNames from 'classnames';
import loaderClasses from '../Loader/Loader.module.scss';
import { Loader } from '../Loader';

export type FluidContentLayoutViewProps = MandatoryChildren<{
  headerTitle?: string;
  loading?: boolean;
  error?: JSX.Element;
  headerActionButton?: JSX.Element;
  resetTranslatePosition?: boolean;
}>;

export const FluidContentLayoutView = (props: FluidContentLayoutViewProps): JSX.Element => {
  const { headerActionButton, headerTitle, children, error, loading, resetTranslatePosition } = props;
  const { state: topNavOffsetState } = useContext(TopNavContext);
  const topNavClasses = useTopNavClasses(topNavOffsetState);

  const rootClasses = classNames(classes.FluidContentLayout, {
    [classes.FluidContentLayoutResetTranslatePosition]: resetTranslatePosition
  });
  // const wrapperClasses = classNames(classes.FluidContentWrapper);
  const pageLoaderClasses = classNames(loaderClasses.PageLoaderWrapper, topNavClasses.vheight);
  const headerClasses = classNames('grid-x', classes.HeaderContainer, {
    'align-justify': headerTitle,
    'align-right': !headerTitle && headerActionButton
  });

  return (
    <div className={rootClasses}>
      {loading ? (
        <div className={pageLoaderClasses}>
          <Loader variation={'dark'} size={'large'} />
        </div>
      ) : error ? (
        error
      ) : (
        <Fragment>
          <div className={headerClasses}>
            {headerTitle && (
              <div className={'cell shrink'}>
                <h3
                  className={
                    'margin-bottom-small-24 margin-bottom-large-32 margin-top-small-24 margin-top-large-32 one-liner'
                  }>
                  {headerTitle}
                </h3>
              </div>
            )}
            {headerActionButton && (
              <div className={'cell shrink'}>
                <div
                  className={`align-right margin-bottom-small-16 margin-top-small-16 margin-bottom-large-20 margin-top-large-20`}>
                  {headerActionButton}
                </div>
              </div>
            )}
          </div>
          {children}
        </Fragment>
      )}
    </div>
  );
};
